import React, { useEffect, FC, memo } from 'react';
import classNames from 'classnames';

import IconX from 'ui/icons/X';
import IconButton from 'ui/IconButton';

import { DatePickerCalendarContainerProps } from './types';

import styles from './index.module.scss';

const DatePickerCalendarContainer: FC<DatePickerCalendarContainerProps> = ({
  className,
  htmlFor,
  label,
  scrollToId,
  children,
  onClose,
}) => {
  useEffect(() => {
    const el = document.querySelector(`#${scrollToId}`);

    if (el && typeof el.scrollIntoView === 'function') {
      el.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }, [scrollToId]);

  return (
    <div
      className={classNames(className, styles.container)}
      id={`${htmlFor}_header`}>
      <div className={styles.header}>
        <label
          htmlFor={htmlFor}
          className={styles.headerLabel}>
          {label || ''}
        </label>
        <IconButton
          elementId={`${htmlFor}_button__close`}
          className={styles.headerButton}
          onClick={onClose}>
          <IconX />
        </IconButton>
      </div>
      {children}
    </div>
  );
};

export default memo(DatePickerCalendarContainer);
